import { render, staticRenderFns } from "./ContentHtmlInput.vue?vue&type=template&id=a2106d40"
import script from "./ContentHtmlInput.vue?vue&type=script&lang=ts"
export * from "./ContentHtmlInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports